import { render, staticRenderFns } from "./BasicSalaryAmount.vue?vue&type=template&id=288e3546"
import script from "./BasicSalaryAmount.vue?vue&type=script&lang=js"
export * from "./BasicSalaryAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports